const genericEmbed = {
  displayField: null,
  name: 'Generic Embed',
  description: '',
  fields: [
    {
      id: 'jsonObject',
      name: 'JSON object',
      type: 'Object',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'genericEmbed',
    version: 2,
    updatedAt: '2023-08-24T20:32:00.413Z'
  }
};
export default genericEmbed;